import React, { useEffect, useState, useRef } from "react";
import api from "../../../api";
import PDFGenerator from "../../../components/PDFGenerator/PDFGenerator";
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

const SetTargetReports = ({uid}) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [selectedYear, setSelectedYear] = useState("");
    const [activeTab, setActiveTab] = useState(""); // Tracks the active tab
    let [tabData, setTabData] = useState([]);
    const [tabLoading, setTabLoading] = useState(false);
  
    useEffect(() => {
      const fetchData = async () => {
        try {
          setLoading(true);
          const res = await api.get(`/api/users/getacademicyear/${uid}`);
          setData(res.data);
        } catch (err) {
          console.error("Error fetching academic years:", err);
        } finally {
          setLoading(false);
        }
      };
  
      fetchData();
    }, [uid]);
  
    const handleYearChange = (event) => {
      setSelectedYear(event.target.value);
      setActiveTab(""); // Reset active tab when a new year is selected
      setTabData([]); // Clear previous tab data
    };
  
    const handleTabClick = async (tab) => {
      setActiveTab(tab);
      try {
        setTabLoading(true);
        const res = await api.get(`/api/reports/coursewise/${tab}/${uid}`, {
          params: { selectedYear }, // Pass the selectedYear as query params
        });
        setTabData(res.data);
      } catch (err) {
        console.error(`Error fetching ${tab} data:`, err);
      } finally {
        setTabLoading(false);
      }
    };
    const tableRefs = useRef([]);
  
    const addToRefs = (el) => {
      if (el && !tableRefs.current.includes(el)) {
        tableRefs.current.push(el);
      }
    };

    
    const generatePDF = async () => {
      setLoading(true);
      const pdf = new jsPDF();
      const pageHeight = pdf.internal.pageSize.height; // Page height in mm
      const pageWidth = pdf.internal.pageSize.width; // Page width in mm
    
      // Header image from public folder
      const collegeHeader = '/images/CollegeHeader.png';
    
      let yPosition = 20; // Initial Y position after the header
      let isFirstTable = true; // Flag to check if it's the first table
    
      for (const table of tableRefs.current) {
        if (table) {
          // Add header image
          const headerImage = new Image();
          headerImage.src = collegeHeader;
    
          // Wait for the header image to load
          await new Promise((resolve) => {
            headerImage.onload = resolve;
          });
    
          // Add the header image to the PDF
          pdf.addImage(headerImage, 'PNG', 10, 10, pageWidth - 20, 20);
    
          // Adjust position for the first table
          if (isFirstTable) {
            yPosition += 20; // Move down after header
            isFirstTable = false;
          }
    
          // Get table rows and thead separately
          const thead = table.querySelector('thead');
          const rows = table.querySelectorAll('tbody tr');
    
          // Capture thead as an image
          if (thead) {
            const canvas = await html2canvas(thead);
            const imgData = canvas.toDataURL('image/png');
            const imgWidth = pageWidth - 20;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
    
            // Add thead image to the PDF
            pdf.addImage(imgData, 'PNG', 10, yPosition, imgWidth, imgHeight);
            yPosition += imgHeight; // Update Y position after thead
          }
    
          // Calculate row height (approximate)
          const rowHeight = 10;
    
          for (const row of rows) {
            // If adding the next row will exceed the page height, add a new page
            if (yPosition + rowHeight > pageHeight - 20) {
              pdf.addPage();
              yPosition = 20; // Reset Y position for new page
    
              // Re-add header image to the new page
              pdf.addImage(headerImage, 'PNG', 10, 10, pageWidth - 20, 20);
              yPosition += 20; // Move down after header
    
              // Re-add the thead on the new page
              if (thead) {
                const canvas = await html2canvas(thead);
                const imgData = canvas.toDataURL('image/png');
                const imgWidth = pageWidth - 20;
                const imgHeight = (canvas.height * imgWidth) / canvas.width;
                pdf.addImage(imgData, 'PNG', 10, yPosition, imgWidth, imgHeight);
                yPosition += imgHeight; // Update Y position after thead
              }
            }
    
            // Capture row as an image
            const canvas = await html2canvas(row);
            const imgData = canvas.toDataURL('image/png');
            const imgWidth = pageWidth - 20;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
    
            // Add row image to the PDF
            pdf.addImage(imgData, 'PNG', 10, yPosition, imgWidth, imgHeight);
            yPosition += imgHeight; // Update Y position for next row
          }
    
          // Add some space between tables
          yPosition += 10;
        }
      }
    
      // Save the PDF
      pdf.save('tables.pdf');
      setLoading(false);
    };
    







  
    console.log(tabData);
  
    return (
      <div className="w-full mt-8">
        <h1 className="text-2xl font-bold mb-6 text-center">
          Set/Target Reports
        </h1>
        {loading ? (
          <p className="text-blue-500 text-center">Loading academic years...</p>
        ) : (
          <div className="w-full max-w-md mx-auto">
            <label
              htmlFor="academicYear"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Select Academic Year:
            </label>
            <select
              id="academicYear"
              value={selectedYear}
              onChange={handleYearChange}
              className="block w-full p-2.5 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="" disabled>
                -- Select Academic Year --
              </option>
              {data.map((item, index) => (
                <option key={index} value={item.academic_year}>
                  {item.academic_year}
                </option>
              ))}
            </select>
          </div>
        )}
  
        {selectedYear && (
          <div className="mt-8">
            <div className="flex justify-center space-x-4 border-b border-gray-300">
              <button
                onClick={() => handleTabClick("set")}
                className={`pb-2 px-4 ${
                  activeTab === "set"
                    ? "text-blue-500 border-b-2 border-blue-500"
                    : "text-gray-600 hover:text-blue-500"
                }`}
              >
                Set
              </button>
              <button
                onClick={() => handleTabClick("target")}
                className={`pb-2 px-4 ${
                  activeTab === "target"
                    ? "text-blue-500 border-b-2 border-blue-500"
                    : "text-gray-600 hover:text-blue-500"
                }`}
              >
                Target
              </button>
            </div>
            {tabLoading ? (
              <p className="mt-4 text-center text-blue-500">
                Loading {activeTab} data...
              </p>
            ) : (
              <div className="mt-4 ">
                {tabData.length > 0 ? (
                  <>
                    <div>
                      <table class="table-auto w-full border border-gray-300">
                        <thead class="bg-gray-100">
                          <tr>
                            <th
                              colspan="16"
                              class="p-4 text-xl font-bold text-center text-purple-900 border border-gray-300"
                            >
                              3.1.3 Program Level Course-PO Matrix of All Courses
                              INCLUDING First Year Courses (10) {selectedYear}
                            </th>
                          </tr>
  
                          <tr>
                            <td
                              colspan="16"
                              class="text-sm text-center text-gray-700 border border-gray-300 p-4"
                            >
                              Following table 3.1.4 shows the details of Program
                              Level Course-PO Matrix of all courses including
                              first year courses. The correlation levels 1, 2, 3
                              are defined as below:
                              <div class="flex justify-around mt-2">
                                <ul class="list-disc pl-8">
                                  <li>
                                    <strong>1:</strong> Slight (Low)
                                  </li>
                                  <li>
                                    <strong>2:</strong> Moderate (Medium)
                                  </li>
                                </ul>
  
                                <ul class="list-disc pl-8">
                                  <li>
                                    <strong>3:</strong> Substantial (High)
                                  </li>
                                  <li>
                                    <strong>-:</strong> For no correlation
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        </thead>
                      </table>
                    </div>
                    <div className="overflow-auto"     ref={addToRefs}>
                      <table
                    
                        className=" table-auto w-full text-left border border-gray-300"
                      >
                        <thead className="bg-purple-900 text-white">
                          <tr>
                            {[
                              "Sr No",
                              "COURSE CODE",
                              "PO1",
                              "PO2",
                              "PO3",
                              "PO4",
                              "PO5",
                              "PO6",
                              "PO7",
                              "PO8",
                              "PO9",
                              "PO10",
                              "PO11",
                              "PO12",
                              "PSO1",
                              "PSO2",
                            ].map((key, index) => (
                              <th
                                key={index}
                                className="p-2 border border-gray-300"
                              >
                                {key}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {tabData.map((item, rowIndex) => (
                            <tr
                              key={rowIndex}
                              className={
                                rowIndex % 2 === 0
                                  ? "bg-purple-200"
                                  : "bg-purple-100"
                              }
                            >
                              <td className="p-2 border border-gray-300">
                                {rowIndex + 1}
                              </td>
                              <td className="p-2 border border-gray-300">
                                {item.coursecode || "-"}
                              </td>
                              <td className="p-2 border border-gray-300">
                                {item.po_1 || "-"}
                              </td>
                              <td className="p-2 border border-gray-300">
                                {item.po_2 || "-"}
                              </td>
                              <td className="p-2 border border-gray-300">
                                {item.po_3 || "-"}
                              </td>
                              <td className="p-2 border border-gray-300">
                                {item.po_4 || "-"}
                              </td>
                              <td className="p-2 border border-gray-300">
                                {item.po_5 || "-"}
                              </td>
                              <td className="p-2 border border-gray-300">
                                {item.po_6 || "-"}
                              </td>
                              <td className="p-2 border border-gray-300">
                                {item.po_7 || "-"}
                              </td>
                              <td className="p-2 border border-gray-300">
                                {item.po_8 || "-"}
                              </td>
                              <td className="p-2 border border-gray-300">
                                {item.po_9 || "-"}
                              </td>
                              <td className="p-2 border border-gray-300">
                                {item.po_10 || "-"}
                              </td>
                              <td className="p-2 border border-gray-300">
                                {item.po_11 || "-"}
                              </td>
                              <td className="p-2 border border-gray-300">
                                {item.po_12 || "-"}
                              </td>
                              <td className="p-2 border border-gray-300">
                                {item.pso_1 || "-"}
                              </td>
                              <td className="p-2 border border-gray-300">
                                {item.pso_2 || "-"}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <button
      onClick={generatePDF}
      className="bg-purple-600 mt-4 text-white px-4 py-2 rounded hover:bg-purple-700"
    >
     {loading ? "Printing..." : "Download PDF"}
    </button>
                  </>
                ) : (
                  <p className="text-center text-gray-600">
                    No data available for {activeTab}.
                  </p>
                )}
              </div>
            )}
          </div>
        )}
          {/* <PDFGenerator tableRefs={tableRefs} /> */}
      </div>
    );
}

export default SetTargetReports